import React, { Fragment } from 'react';
import { ArrowLeftIcon, Icon, Image } from '@/components';
import router from 'next/router';

const ProductHideLayout = () => {
  return (
    <Fragment>
      <div className="container tw-mx-auto md:tw-border-t tw-border-primary-main tw-pt-20 md:tw-pt-6 md:tw-pb-14 tw-pb-20 tw-h-full">
        <div className="tw-fixed tw-block md:tw-hidden tw-z-50 tw-top-6 tw-left-4">
          <div
            className="tw-w-10 tw-h-10 tw-rounded-full tw-bg-gray-10 tw-flex   tw-items-center tw-justify-center"
            onClick={() => router.back()}
          >
            <Icon className="tw-w-6 tw-h-6 tw-text-primary-main" icon={<ArrowLeftIcon />} />
          </div>
        </div>
        <div className="tw-text-secondary-70">Sản phẩm</div>
        <div className="tw-flex tw-items-center tw-justify-center tw-flex-col md:tw-flex-row tw-gap-6 lg:tw-gap-10 tw-mt-10 md:tw-mt-20 lg:tw-mt-20 xl:tw-mt-40">
          <div className="tw-text-xl tw-text-center md:tw-text-left">
            Sản phẩm đang được chỉnh sửa vui lòng chờ mở bán lại
          </div>
          <Image
            alt="hide-product"
            src="/hide-product.png"
            className="tw-order-first md:tw-order-last tw-w-full tw-h-[250px] md:tw-w-[300px] md:tw-h-[200px] lg:tw-w-[400px] lg:tw-h-[266px]"
          />
        </div>
      </div>
    </Fragment>
  );
};

export default ProductHideLayout;
